/* eslint-disable  */
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';

const fetchWhips = async () => {
    const { data } = await api.get('/whips');

    return data;
};

const createWhip = async payload => {
    const { data } = await api.post('/whips', payload);

    return data;
};

const updateWhip = async payload => {
    const { data } = await api.put('/whips', payload);

    return data;
};

const deleteWhip = async id => {

    const { data } = await api.delete(`/whips/${id}`);

    return data;
};

export const useWhips = (queryOptions = {}) => useQuery('whips', fetchWhips, queryOptions);


export const useUpdateWhip = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => updateWhip(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('whips');
        },
        ...queryOptions
    });
};

export const useCreateWhip = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => createWhip(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('whips');
        },
        ...queryOptions
    });
};

export const useDeleteWhip = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(whipId => deleteWhip(whipId), {
        onSuccess: () => {
            queryClient.invalidateQueries('whips');
        },
        ...queryOptions
    });
};
